import formDefaultState from 'shared/flight/defaultState.js';

export default {
    skeleton: !!window.FINN?.travel?.enableSkeletonScreen,

    showSearchDetails: true,
    showSearchForm: false,

    showFilters: false,
    showMobileFilters: false,
    showMobileFilterOverlay: false,

    showExpiredResultsMessage: false,

    savedSearch: {
        currentState: {},
        enabled: false,
        showModal: false,
        unsavedChanges: false,
        searchWasSaved: false,
        name: '',
    },

    searchForm: Object.assign({}, formDefaultState, { pristine: true }),

    filterData: {},
    filterState: Object.assign({}, window.FINN && window.FINN.travel && window.FINN.travel.unCheckedFilters),

    showProgressIndicator: false,
    progress: 0,
    progressClass: '',
    pollingComplete: false,
    loading: false,

    searchId: null,
    request: {},
    stats: null,
    trips: [],
    numberOfResults: 0,
    bestOffers: null,
    supremeOffer: null,

    lowfare: {
        data: [],
        showLowfare: false,
        showCalendar: false,
        originalSearch: {},
        numberOfDays: {},
        searching: false,
    },

    pagination: {
        showPagination: false,
        rewind: false,
        previousPages: [],
        previousPage: 0,
        currentPage: 1,
        nextPage: 2,
        consecutivePages: [],
    },
};
